import useBillingPaymentMake from 'modules/queries/billing/payment/useMake';
import usePaypalPaymentCreate from 'modules/queries/billing/paypal/payment/useCreate';
import useBillingStripePaymentMake from 'modules/queries/billing/stripe/payment/useMake';
import useBrandName from 'utility/hooks/useBrandName';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import ConfirmPaymentContent from './ConfirmPayment';
import useChosenPaymentMethod from '../useChosenPaymentMethod';

/** Confirms a payment on a method the account already has on file */
const ConfirmSavedPayment = () => {
	const {
		accountBalanceDisplay,
		authorizedAmount,
		formValues,
		paymentIntentId,
		onSubmitSuccess,
		onSubmitError,
	} = useDialogMakePaymentContext();
	const { chosenPaymentMethod } = useChosenPaymentMethod();
	const {
		paymentMethod,
		paymentProfileId,
		processor,
		issuer,
		label = '',
		secondaryLabel,
	} = chosenPaymentMethod || {};
	const { mutate: makePayment, isLoading: isMakingPayment } =
		useBillingPaymentMake();
	const { mutate: paypalPaymentCreate, isLoading: isPaypalCreating } =
		usePaypalPaymentCreate();
	const { mutate: makeStripePayment, isLoading: isMakingStripePayment } =
		useBillingStripePaymentMake();
	const brandName = useBrandName();

	const { amount, cardCode } = formValues;

	const handleSubmit = () => {
		if (processor === 'stripe') {
			makeStripePayment(
				// what the card was authorized for, which a capture may not exceed
				{ amount: authorizedAmount, payment_intent_id: paymentIntentId },
				{
					onSuccess: onSubmitSuccess,
					onError: onSubmitError,
				},
			);

			return;
		}

		if (processor === 'paypal') {
			paypalPaymentCreate(
				{
					requested_amount: amount,
					lineItems: [{ amount, description: `My ${brandName} Payment` }],
					returnURL: `${window.location.origin}/account/billing`,
				},
				{
					onSuccess: onSubmitSuccess,
					onError: onSubmitError,
				},
			);

			return;
		}

		if (paymentMethod === 'ach') {
			makePayment(
				{
					amount,
					payment_profile_id: paymentProfileId,
				},
				{
					onSuccess: onSubmitSuccess,
					onError: onSubmitError,
				},
			);

			return;
		}

		makePayment(
			{
				amount,
				card_code: cardCode,
				payment_profile_id: paymentProfileId,
			},
			{
				onSuccess: onSubmitSuccess,
				onError: onSubmitError,
			},
		);
	};

	return (
		<ConfirmPaymentContent
			accountBalance={Number(accountBalanceDisplay)}
			amount={Number(amount)}
			isSubmitting={
				isMakingPayment || isPaypalCreating || isMakingStripePayment
			}
			issuer={issuer}
			label={label}
			onSubmit={handleSubmit}
			paymentMethod={processor === 'paypal' ? 'paypal' : paymentMethod}
			secondaryLabel={secondaryLabel}
		/>
	);
};

export default ConfirmSavedPayment;
